import EventsContainer from './events-container';

export default EventsContainer;
